import { loadScript } from '../load-strategies/YoutubeSdkLoader';

export default {
  name: 'youtube',
  loader: loadScript,
};
